import React from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogContentText, 
    DialogActions, 
    Button,
    Typography,
    Box
} from '@mui/material';
import LockClockIcon from '@mui/icons-material/LockClock';
import { useNavigate } from 'react-router-dom';

const SessionExpiredDialog = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleLoginRedirect = () => {
        onClose();
        navigate('/login');
    };

    return (
        <Dialog 
            open={open} 
            onClose={(event, reason) => {
                // Previne fechar clicando fora ou no ESC para forçar o login
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onClose();
                }
            }}
            aria-labelledby="session-expired-dialog-title"
        >
            <DialogTitle id="session-expired-dialog-title" sx={{ textAlign: 'center', pt: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <LockClockIcon color="warning" sx={{ fontSize: 60 }} />
                    <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                        Sessão Expirada
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center', px: 4 }}>
                <DialogContentText sx={{ color: 'text.primary', fontSize: '1.1rem', mt: 1 }}>
                    Sua sessão expirou por inatividade ou o tempo de acesso acabou.
                    <br />
                    Por segurança, você precisa fazer login novamente para continuar.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 4, pt: 2 }}>
                <Button 
                    onClick={handleLoginRedirect} 
                    variant="contained" 
                    color="primary" 
                    size="large"
                    sx={{ px: 4, borderRadius: 2 }}
                >
                    Ir para o Login
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredDialog;
